import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import PhoneUpdateStep1UI from './PhoneUpdateStep1UI.js'

class PhoneUpdateStep1SF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: [],
      submitted: false,
    }
  }

  render() {
    return (
      <PhoneUpdateStep1UI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        // old phone number
        oldPhoneNumber={this.props.oldPhoneNumber}
        onOldPhoneNumberChange={this.props.onOldPhoneNumberChange}
        oldPhoneNumberError={this.props.oldPhoneNumberError}
        setOldPhoneNumberError={this.props.setOldPhoneNumberError}
        // new phone number
        newPhoneNumber={this.props.newPhoneNumber}
        onNewPhoneNumberChange={this.props.onNewPhoneNumberChange}
        newPhoneNumberError={this.props.newPhoneNumberError}
        setNewPhoneNumberError={this.props.setNewPhoneNumberError}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/user/newPhone/verification`,
      this.onSubmitCallback, {
        phoneNumber: this.props.newPhoneNumber
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'phoneNumber':
            this.props.setNewPhoneNumberError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({
      successMsg: response.success,
      submitted: false
    })

    if (errorList.length === 0) {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
      this.props.setView('verification')
    }
  }

  getMessages(context) {
    let arr = [
      'c_phone_number_existing',
      'c_phone_number_new',
      'c_tip_verify_phone',
      'c_continue',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_phone_upd_1', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default PhoneUpdateStep1SF
